import { render, staticRenderFns } from "./form.vue?vue&type=template&id=2ae6fb8a&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
import style0 from "./form.vue?vue&type=style&index=0&id=2ae6fb8a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae6fb8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ae6fb8a')) {
      api.createRecord('2ae6fb8a', component.options)
    } else {
      api.reload('2ae6fb8a', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=2ae6fb8a&scoped=true", function () {
      api.rerender('2ae6fb8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/other/counterfeiting/form/form.vue"
export default component.exports